import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDialogComponent } from 'src/app/controls/components/advanced/modal-dialog/modal-dialog.component';
import { ButtonComponent } from 'src/app/controls/components/basic/button/button.component';
import { ButtonPrimaryDirective } from 'src/app/controls/directives/button-primary.directive';
import { ButtonSecondaryDirective } from 'src/app/controls/directives/button-secondary.directive';
import { LayoutColumnComponent } from 'src/app/controls/components/basic/layout-column/layout-column.component';
import { LayoutRowComponent } from 'src/app/controls/components/basic/layout-row/layout-row.component';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-partner-onboarding-accept-dialog',
  standalone: true,
  imports: [ModalDialogComponent, FormsModule, ButtonComponent, ButtonPrimaryDirective, ButtonSecondaryDirective, ModalDialogComponent, LayoutColumnComponent, LayoutRowComponent],
  templateUrl: './partner-onboarding-accept-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './partner-onboarding-accept-dialog.component.scss'
})
export class PartnerOnboardingAcceptDialogComponent {

  private dialog = inject(NgbActiveModal);

  accept() {
    this.dialog.close(PartnerOnboardingAcceptDialogResult.Accept);
  }

  acceptAndCreate() {
    this.dialog.close(PartnerOnboardingAcceptDialogResult.AcceptAndCreate);
  }

  cancel() {
    this.dialog.close(PartnerOnboardingAcceptDialogResult.Cancel);
  }
}

export enum PartnerOnboardingAcceptDialogResult {
  Accept,
  AcceptAndCreate,
  Cancel 
}
